import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const PopupTableModal = ({ data, show, onClose, onSubmit }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);

    useEffect(() => {
        if (!show) {
            setSelectedIndex(null); // Clear selected row when modal closes
        }
    }, [show]);
    if (
        !data ||
        typeof data !== 'object' ||
        Array.isArray(data) ||
        Object.keys(data).length === 0 ||
        !Object.values(data).every(val => Array.isArray(val)) ||
        new Set(Object.values(data).map(val => val.length)).size !== 1
    ) {
        // console.error("Invalid or malformed data for popup table:", data);
        return null;
    }


    const keys = Object.keys(data);
    const rowCount = data[keys[0]]?.length || 0;

    const handleSubmit = () => {
        if (selectedIndex === null) {
            console.log("Please select a row!");
            return;
        }

        const selectedRowData = {};
        keys.forEach((key) => {
            selectedRowData[key] = data[key][selectedIndex];
        });

        onSubmit(selectedRowData);
        onClose();
    };

    return (
        <Modal show={show} onHide={onClose} size="xl" centered style={{ marginTop: '4vh' }}>
            <Modal.Header closeButton>
                <Modal.Title>Select a Row</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: 'auto' }}>
                <div className='table-on-homepage-only w-100'>
                    <table className="table table-bordered table-hover">
                        <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                            <tr>
                                <th>Select</th>
                                {keys.map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {[...Array(rowCount)].map((_, i) => (
                                <tr key={i}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="rowSelection"
                                            value={i}
                                            checked={selectedIndex == i}
                                            onChange={() => setSelectedIndex(i)}
                                        />
                                    </td>
                                    {keys.map((key) => (
                                        <td key={key}>{data[key][i]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Close</Button>
                {/* <Button variant="primary" onClick={handleSubmit} disabled={selectedIndex === null} title="Select row">Submit</Button> */}
                <span
                    title={selectedIndex === null ? "Please select a row first" : "Submit selected row"}
                    style={{ display: 'inline-block' }}
                >
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={selectedIndex === null}
                    >
                        Submit
                    </Button>
                </span>


            </Modal.Footer>
        </Modal>
    );
};

export default PopupTableModal;
